import { cn } from "@/lib/utils";
import Image from "next/image";

interface MetaItem {
  id: string;
  meta_logo: string;
  meta_description: string;
  meta_priority: number;
  meta_alt_image?: string;
  meta_description_text_color?: string;
}

const AccreditationCard = ({
  item,
  index,
}: {
  item: MetaItem;
  index: number;
}) => {
  return (
    <div
      key={`${item.id}`}
      className={cn(
        "flex flex-row items-center justify-center p-spacing-6 gap-spacing-12 w-[152px]",
        "sm:flex-col sm:gap-spacing-14 sm:p-spacing-8",

        "sm:w-[182px] ",
        "md:w-[188px] ",
        "lg:w-[208px] ",
        "xl:w-[272px] ",
      )}
    >
      <div
        className={cn(
          "flex items-center justify-center w-[42px] h-[42px] rounded-full",
          "sm:w-[142px] sm:h-[68px] sm:rounded-none",
          "md:w-[162px] md:h-[88px] md:rounded-none",
          "lg:w-[182px] lg:h-[88px] lg:rounded-none",
          "xl:w-[242px] xl:h-[108px] xl:rounded-none",
        )}
      >
        {item?.meta_logo && (
          <Image
            src={item?.meta_logo || ""}
            alt={item.meta_alt_image || "Accreditation logo"}
            width={100}
            height={100}
            className="w-full h-full object-contain"
          />
        )}
      </div>
      <div
        className={cn(
          "text-start sm:text-center w-[88px] text-body-4-regular",
          "sm:text-heading-9-regular sm:w-[182px]",
          "md:text-heading-8-regular md:w-[188px]",
          "lg:text-heading-7-regular lg:w-[208px]",
          "xl:text-new-body-24-regular xl:w-[272px]",
          "line-clamp-2 sm:line-clamp-1",
          "type-body-sm",
        )}
        style={{
          color: item?.meta_description_text_color || "#000000",
        }}
      >
        {item?.meta_description}
      </div>
    </div>
  );
};

export default AccreditationCard;
